import { setDates } from "@api/models/helpers/DatesSetter";

import { UserProfile } from "@api/models/UserProfile";
import { DropDownItem } from "@share/common/drop-down/types";
import { DateTime } from "luxon";

export interface CommitteeFormModelInterface {
    id?: string;
    title: string;
    description?: string;
    userProfiles: UserProfile[];
    ticketIds: string[];
    beginAt: DateTime | null;
    endAt: DateTime | null;

    subjectType: DropDownItem<string>;
    company: DropDownItem<string>;
    secretary: DropDownItem<number>;

    location?: string;
    link?: string;

    needReset?: boolean;
}
export class CommitteeFormModel implements CommitteeFormModelInterface {
    id?: string;
    title = "";
    description?: string = "";
    userProfiles: UserProfile[] = [];
    ticketIds: string[] = [];
    beginAt: DateTime | null = null;
    endAt: DateTime | null = null;
    subjectType: DropDownItem<string> = { id: "", title: "" };
    company: DropDownItem<string> = { id: "", title: "" };
    secretary: DropDownItem<number> = { id: 0, title: "" };
    location?: string = "";
    link?: string = "";

    #copy: string | null = null;

    constructor(data?: CommitteeFormModelInterface) {
        Object.assign(this, data);
        setDates(this, ['beginAt', 'endAt']);

        this.resetCopy();
    }

    resetCopy() {
        this.#copy = JSON.stringify(this);
    }

    /**
     * reset fields to init values
     */
    reset() {
        Object.assign(this, JSON.parse(this.#copy || ""));
    }

    get needReset() {
        return JSON.stringify(this) !== this.#copy;
    }
}